/* eslint-disable no-return-await */
/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import op from 'object-path'
import { Indicator, Toast } from 'mint-ui'

import serviceCake from '../service/cakeStore'
import service from '../service/city'
import CONSTANT from '../constant/city'
import COOKIECONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import { resolveAddress } from '../util/function'
import { initAmap, geoCode } from '../util/amap'

const getCityList = ({ commit }) => {
  return new Promise((resolve, reject) => {
    return service.getCityList().then((list) => {
      commit(CONSTANT.CITY_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.CITY_GET_LIST_ERROR, e)
      reject(e)
    })
  })
}

const getGPSPosition = async ({ commit }) => {
  let pos = {
    latitude: '0',
    longitude: '0',
  }
  const options = {
    timeout: 2000, // web api 定位超时时间
    maximumAge: 0,  // 不使用缓存地址
  }
  return await new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      throw new Error('Geolocation is not supported by this browser')
    }
    Indicator.open({
      text: '定位中...',
      spinnerType: '',
    })
    navigator.geolocation.getCurrentPosition((position) => {
      Indicator.close()
      pos = {
        longitude: position.coords.longitude,
        latitude: position.coords.latitude,
      }
      commit(CONSTANT.CITY_SET_GPS_POSITION, pos)
      return resolve(pos)
    }, (err) => {
      Indicator.close()
      Toast({
        message: '定位失败',
        position: 'bottom',
      })
      console.log('获取经纬度失败', err)
      commit(CONSTANT.CITY_SET_GPS_POSITION, pos)
      return reject(err)
    }, options)
  })
}

const getLocate = ({ commit }) => {
  return new Promise((resolve, reject) => {
    return getGPSPosition({ commit }).then((pos) => {
      return service.getLocate(pos).then((list) => {
        commit(CONSTANT.CITY_GET_LOCATE_SUCCESS, list)
        resolve(list)
      }, (e) => {
        commit(CONSTANT.CITY_GET_LOCATE_ERROR, e)
        reject(e)
      })
    }).catch((err) => {
      reject(err)
    })
  })
}


const getCityCenterCode = async ({ commit }, address) => {
  try {
    return geoCode(address).then((res) => {
      commit(CONSTANT.CITY_SET_CITY_CENTER_LOCATION, res)
      console.log('getCityCenterCode success', res)
      return res
    }).catch((err) => {
      commit(CONSTANT.CITY_SET_CITY_CENTER_LOCATION, {})
      console.log('getCityCenterCode fail', err)
      return err
    })
  } catch (e) {
    console.log('getCityCenterCode catch', e)
    commit(CONSTANT.CITY_SET_CITY_CENTER_LOCATION, {})
    return e
  }
}

const getGPSAddress = ({ commit }) => {
  return initAmap().then(() => {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line consistent-return
      setTimeout(() => {
        if (!window.AMap) {
          return reject('地图加载失败')
        }
        AMap.plugin('AMap.Geolocation', () => {
          const geolocation = new AMap.Geolocation({
            extensions: 'all',
            timeout: 5000,
          })
          geolocation.getCurrentPosition((status, result) => {
            console.log('geolocation', status, result)
            if (status === 'complete' && result) {
              console.log(result)
              console.log(resolveAddress(result))
              debugger
              commit(CONSTANT.CITY_GET_LOCATE_ADDRESS_SUCCESS, resolveAddress(result))
              commit(CONSTANT.CITY_SET_GPS_POSITION, {
                latitude: op.get(result.position.lat),
                longitude: op.get(result.position.lng)
              })
              return resolve(resolveAddress(result))
            }
            commit(CONSTANT.CITY_GET_LOCATE_ADDRESS_ERROR, result)
            return reject(result)
          })
        })
      }, 1000)
    })
  })
}
// 高德地图定位地址保存获取地址映射ID
const setGPSAddress = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    return service.setGPSAddress(data).then((result) => {
      data.addressId = result.addressId
      data.name = data.address
      cookie(COOKIECONSTANT.COOKIE_PRODUCT_DELIVERY, JSON.stringify({
        addressType: 0,
        addressValue: 0,
      }))
      commit(CONSTANT.CITY_CHANGE_SHIPPING_ADDRESS, data)
      resolve(result)
    }, (e) => {
      commit(CONSTANT.CITY_CHANGE_SHIPPING_ADDRESS, data)
      reject(e)
    })
  })
}

const getCakeStoreCitys = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    return serviceCake.getCakeStoreCitys(data).then((list) => {
      console.log(list, 'list ==== city')
      commit(CONSTANT.CAKESTORECITY_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.CAKESTORECITY_GET_LIST_ERROR, e)
      reject(e)
    })
  })
}

const getCakeStore = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    return serviceCake.getCakeStore(data).then((list) => {
      commit(CONSTANT.CAKESTORE_GET_LIST_SUCCESS, list)
      resolve(list)
    }, (e) => {
      commit(CONSTANT.CAKESTORE_GET_LIST_ERROR, e)
      reject(e)
    })
  })
}

export default {
  getCityList,
  getLocate,
  getGPSPosition,
  getGPSAddress,
  setGPSAddress,
  getCakeStoreCitys,
  getCakeStore,
  getCityCenterCode,
}
